import { viewpointEmptyState$ } from './viewpointEmptyState$';
import { connect } from '@ardoq/rxbeach';
import { EmptyStateLayout } from 'tabview/graphViews/emptyStates/EmptyStateLayout';
import { ViewpointEmptyStateData } from './types';

const ViewpointEmptyStateBase = ({
  emptyStateLayout,
}: ViewpointEmptyStateData) =>
  emptyStateLayout ? <EmptyStateLayout {...emptyStateLayout} /> : null;

export const ViewpointEmptyState = connect(
  ViewpointEmptyStateBase,
  viewpointEmptyState$
);
